import React from 'react';

import './LoadMore.scss';

const LoadMore = () => {
	return (
		<svg className="LoadMore" viewBox="0 0 120 120" >
			<g>
	            <circle className="circle" cx="60" cy="60" r="43.5"/>
    	        <g>
                    <path className="arrow" d="M40.5,82c-0.2-0.1-0.3-0.2-0.5-0.2c-1.2-0.6-1.5-2.1-0.7-3.1c0.3-0.4,0.7-0.8,1.1-1.2
                        c5.4-5.7,10.8-11.4,16.3-17.2c0.1-0.1,0.2-0.2,0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.4c-5.7-6-11.3-12-17-18c-0.5-0.6-0.9-1.2-0.7-2
                        c0.2-0.8,0.7-1.3,1.4-1.6c0.8-0.3,1.6,0,2.2,0.6c1.1,1.1,2.1,2.2,3.2,3.3c5.1,5.4,10.3,10.9,15.4,16.3c1.1,1.2,1.1,2.3,0,3.4
                        C55,68.2,48.9,74.6,42.7,81.1c-0.4,0.4-0.9,0.6-1.4,1C41,82,40.8,82,40.5,82z"/>
                    <path className="arrow" d="M61.7,82c-0.2-0.1-0.3-0.2-0.5-0.2c-1.2-0.6-1.5-2.1-0.7-3.1c0.3-0.4,0.7-0.8,1.1-1.2
                        c5.4-5.7,10.8-11.4,16.3-17.2c0.1-0.1,0.2-0.2,0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.4c-5.7-6-11.3-12-17-18c-0.5-0.6-0.9-1.2-0.7-2
                        c0.2-0.8,0.7-1.3,1.4-1.6c0.8-0.3,1.6,0,2.2,0.6c1.1,1.1,2.1,2.2,3.2,3.3c5.1,5.4,10.3,10.9,15.4,16.3c1.1,1.2,1.1,2.3,0,3.4
                        C76.2,68.2,70.1,74.6,64,81.1c-0.4,0.4-0.9,0.6-1.4,1C62.3,82,62,82,61.7,82z"/>
	            </g>
            </g>
		</svg>
	);
}

export default LoadMore;